import { Address } from "./adress.model";
import { AssocCategoryModel } from "./assoc-category.model";
import { ImageURI } from "./image-uri.interface";
import { AssocType } from "./assoc-type.interface";
import { Odd } from "./odd.interface";
import { Region } from "./region.interface";
import { ICountry } from "./country.interface";

export class Association {
  id: number;
  about: string;
  actions: string;
  name: string;
  banner: Banner;
  description: string;
  diaporamas: Diaporama[];
  website: string;
  email?: any;
  title: string;
  assoc_object: string;
  assoc_status: string;
  order?: any;
  reduc_fisc_pal_1: number;
  reduc_fisc_pal_2: number;
  logo: ImageURI;
  desc_doc: {
    url?: any;
  };
  event_doc: {
    url?: any;
  };
  is_active: boolean;
  updated_at: string;
  recognized_at: string;
  published_at: string;
  dedicated_part: number;

  mangopay_user_id: string;
  mangopay_wallet_id: string;

  is_impact: boolean;
  video_presentation: string;

  stripe_connect_id?: string | null;
  stripe_connect_status?: string | null;
  stripe_connect_onboarding_step?: string | null;
  stripe_connect_onboarding_url?: string | null;
  stripe_connect_onboarding_emails_sent?: string | null;
  stripe_charges_enabled?: boolean;
  stripe_payouts_enabled?: boolean;

  category: AssocCategoryModel;
  assoc_address: Address;
  assoc_rep: any;
  assoc_types: AssocType[];
  cerfa_type: string;
  certification: string;
  video: string;
  url: string;
  signature: {
    url?: any;
  };
  assoc_code: string;
  equivalence_100euro: string;
  equivalence_30euro: string;
  odds: Odd[];
  regions: Region[];
  countries: String[];
  assoc_categories: AssocCategoryModel[];
  siren: string;
  assoc_cerfa_field: any;
}

export class Diaporama {
  id: number;
  value: {
    url: string;
    thumb: {
      url: string;
    };
  };
  default: boolean;
  title: string;
  description?: any;
  assoc_id: number;
}

interface Banner {
  url: string;
  medium: {
    url: string;
  };
}
